import type { Components } from 'react-markdown'
import ReactMarkdown from 'react-markdown'
import { Text } from '~/shared/ui'

const customComponents: Components = {
  h1: ({ children }) => (
    <Text
      className="my-3 block first:mt-0"
      appearance="H5"
    >
      {children}
    </Text>
  ),
  h2: ({ children }) => (
    <Text
      className="my-3 block first:mt-0"
      appearance="H6"
    >
      {children}
    </Text>
  ),
  h3: ({ children }) => (
    <Text
      className="my-3 block first:mt-0"
      appearance="SUBTITLE"
    >
      {children}
    </Text>
  ),
  h4: ({ children }) => (
    <Text
      className="my-3 block first:mt-0"
      appearance="OVERLINE"
    >
      {children}
    </Text>
  ),
  ul: ({ children }) => <ul className="mx-0 my-2 pl-6">{children}</ul>,
  li: ({ children }) => (
    <li>
      <Text appearance="BODY2">{children}</Text>
    </li>
  ),
  p: ({ children }) => (
    <Text
      className="my-2 block first:mt-0"
      appearance="BODY2"
    >
      {children}
    </Text>
  ),
}

export function ReleaseNoteBody({ content }: { content: string }) {
  return <ReactMarkdown components={customComponents}>{content}</ReactMarkdown>
}
